import { NAV_ITEMS, CATEGORIES } from "@/mocks/contents";

const SOCIALS = [
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-music-2-line", label: "短视频" },
  { icon: "ri-rss-line", label: "RSS" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-200 text-foreground-800" aria-label="页脚">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">吃瓜嘿料</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              聚合实锤证据与石锤图文的娱乐圈吃瓜门户。还原事件脉络、厘清时间线，吃瓜吃到底，真相不遗漏。
            </p>
            <div className="mt-5 flex gap-2">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#home"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`text-lg ${s.icon}`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">栏目导航</h3>
            <ul className="mt-4 space-y-2.5">
              {NAV_ITEMS.map((n) => (
                <li key={n.id}>
                  <a href={n.id} className="text-sm text-foreground-700 transition-colors hover:text-primary-700">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">内容频道</h3>
            <ul className="mt-4 space-y-2.5">
              {CATEGORIES.filter((c) => c.id !== "all").map((c) => (
                <li key={c.id}>
                  <a href="#gallery" className="text-sm text-foreground-700 transition-colors hover:text-primary-700">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
                hello@chiguaheilia.com
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-user-line mt-0.5 text-primary-600" aria-hidden="true"></i>
                <span>更正与投诉：请说明问题定位与凭证，24 小时内核验处理。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-global-line mt-0.5 text-primary-600" aria-hidden="true"></i>
                <span>本网站内容仅面向符合当地规定的读者提供信息聚合服务。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-300/70 pt-6">
          <p className="text-xs leading-relaxed text-foreground-600">
            内容声明：本站聚焦娱乐圈公开热点，对信息仅做整理与梳理，不虚构实名结论，不收录涉及个人隐私的聊天记录与录音，所有内容以不侵犯隐私权与名誉权为前提。配图均为示意图，不代表真实事件场景。
          </p>
        </div>
      </div>

      <div className="border-t border-background-300/70">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-600 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 吃瓜嘿料 ChiGuaHeiLiao · 保留所有权利</p>
          <p className="inline-flex items-center gap-1">
            <i className="ri-user-voice-line text-primary-600" aria-hidden="true"></i>
            人工编辑复核 · 拒绝流量式标题党
          </p>
        </div>
      </div>
    </footer>
  );
}